import axios from 'axios';

// --- Centralized URL Configuration ---
// To switch between local and production, comment out one pair and uncomment the other.

// For Local Development (using localhost ports)
//const ENQUIRY_SERVICE_BASE_URL = 'http://localhost:8082';
//const AUTH_SERVICE_BASE_URL = 'http://localhost:8081';

// For Production Deployment (using domain names)
const ENQUIRY_SERVICE_BASE_URL = 'https://enquiry.ems.eyantra.com';
const AUTH_SERVICE_BASE_URL = 'https://auth.ems.eyantra.com';
// --- End Centralized URL Configuration ---


const instance = axios.create();

export const enquiryService = axios.create({
  baseURL: ENQUIRY_SERVICE_BASE_URL,
  headers: {
    'Content-Type': 'application/json',
  },
});

export const authService = axios.create({
  baseURL: AUTH_SERVICE_BASE_URL,
  headers: {
    'Content-Type': 'application/json',
  },
});


instance.interceptors.request.use(
  config => {
    const token = localStorage.getItem('jwtToken'); // Assuming token is stored as 'jwtToken'
    if (token) {
      config.headers['Authorization'] = `Bearer ${token}`;
    }
    // Ensure Content-Type is set if not already present
    if (!config.headers['Content-Type']) {
        config.headers['Content-Type'] = 'application/json';
    }
    return config;
  },
  error => {
    return Promise.reject(error);
  }
);

enquiryService.interceptors.request.use(
  config => {
    const token = localStorage.getItem('jwtToken');
    if (token) {
      config.headers['Authorization'] = `Bearer ${token}`;
    }
    if (!config.headers['Content-Type']) {
        config.headers['Content-Type'] = 'application/json';
    }
    return config;
  },
  error => {
    return Promise.reject(error);
  }
);

authService.interceptors.request.use(
  config => {
    const token = localStorage.getItem('jwtToken');
    if (token) {
      config.headers['Authorization'] = `Bearer ${token}`;
    }
    if (!config.headers['Content-Type']) {
        config.headers['Content-Type'] = 'application/json';
    }
    return config;
  },
  error => {
    return Promise.reject(error);
  }
);

instance.interceptors.response.use(
  response => response,
  error => {
    if (error.response && error.response.status === 401) {
      console.error("Unauthorized request (401). Token might be invalid or expired.");
    }
    return Promise.reject(error);
  }
);

enquiryService.interceptors.response.use(
  response => response,
  error => {
    if (error.response && error.response.status === 401) {
      console.error("Unauthorized request (401). Token might be invalid or expired for Enquiry Service.");
    }
    return Promise.reject(error);
  }
);

// Response Interceptor for authService
authService.interceptors.response.use(
  response => response,
  error => {
    if (error.response && error.response.status === 401) {
      console.error("Unauthorized request (401). Token might be invalid or expired for Auth Service.");
    }
    return Promise.reject(error);
  }
);


export default instance;
